import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      flexGrow: 1,
      textAlign: 'left',
      width: '100%',
      margin: theme.spacing(2, 'auto'),
      display: theme.withPrint('flex', 'block'),
    },
    p2: {
      padding: theme.spacing(2, 3),
    },
    m2: {
      margin: theme.spacing(2),
    },
    p0p3: {
      padding: theme.spacing(0, 3),
    },
    content: {
      backgroundColor: theme.palette.white.light,
      display: theme.withPrint('flex', 'block'),
    },
    paper: {
      padding: theme.spacing(2),
    },
    hidden: {
      display: 'none',
    },
    widthMarginTop: {
      marginTop: theme.spacing(1),
    },
    noWrap: {
      flexWrap: 'nowrap',
    },
    paymentBreakdown: {
      padding: theme.spacing(2, 2),
    },
    avatarContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    avatarIcon: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    text2left: {
      textAlign: 'left',
    },
    text2right: {
      textAlign: 'right',
    },
    hSpacing: {
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: 'column',
    },
    brokerNotesDescription: {
      margin: '30px',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '22px',
      lineHeight: '34px',
      alignItems: 'center',
      color: theme.palette.borrower.dark,
    },
    color009A73: {
      color: '#009A73',
    },
    borderBottom: {
      borderBottom: '1px solid #eee',
    },
    illustratorChart: {
      display: theme.withPrint('inherit', 'none !important'),
    },
    outer: {
      position: 'relative',
      height: '100%',
    },
    inner: {
      position: 'absolute',
      top: '50%',
      left: '50%',
    },
    rotate: {
      transform: 'translateX(-50%) translateY(-50%) rotate(-90deg)',
    },
    printContainer: {
      display: theme.forPrint('block'),
    },
  }),
  {index: 1},
);

export default useStyles;
